/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cashIn} from '../api'

export const useMutationCashIn = createReactQueryMutationHook('cashIn', cashIn)
